import ReceiveTransferDetails from "./receiveTransferDetails.container";

export default ReceiveTransferDetails;
